/**
 * Parses a decimal string that may use a comma as the decimal separator
 * (common in Czech locale, e.g. "12,50" → 12.5).
 *
 * Returns null for empty strings or strings that produce NaN after normalisation.
 */
export function parseDecimalInput(s: string): number | null {
  if (!s || s.trim() === '') return null;
  // Normalise comma decimal separator to period
  const normalised = s.trim().replace(',', '.');
  const result = parseFloat(normalised);
  return isNaN(result) ? null : result;
}
